function AppLogo() {
    return (
      <div className="app-logo"></div>
    );
};

export default AppLogo;